<template>
  <div
    class="w-unit"
    :style="computedBorderStyle"
    @dblclick="activate"
  >
    <w-row
      v-if="!noHeader || showToggleVisibility"
      no-gutters
      class="w-unit__header"
    >
      <WorkUnitPrependHeader
        v-model="showContentOnXs"
        :show-toggle-visibility="showToggleVisibility"
        :content-class="getIsArrowClass()"
      />
      <w-column>
        <h4 v-if="title || showToggleVisibility">
          {{ title }}
        </h4>
      </w-column>
      <v-spacer v-if="isHeaderSpacerVisible" />
      <w-column
        v-if="showHeaderAppend"
        cols="auto"
        class="d-flex align-center justify-end"
      >
        <w-row
          no-gutters
          class="w-unit__header__append"
        >
          <slot
            name="header-append"
            :readonly="_readOnly"
          />
        </w-row>
      </w-column>
      <w-column
        cols="auto"
        class="d-flex align-center justify-end"
      >
        <w-row
          no-gutters
          class="w-unit__header__append"
        >
          <slot name="permanent-header-append" />
        </w-row>
      </w-column>
    </w-row>
    <v-container
      v-show="isUnitContentVisible"
      :class="{
        'w-unit__content': true,
        'w-unit__content--no-header': noHeader,
      }"
      fluid
    >
      <slot :readonly="_readOnly" />
    </v-container>
    <v-container
      v-if="$slots['no-padding-content'] && isUnitContentVisible"
      class="pa-0 w-unit__content"
      fluid
    >
      <slot
        name="no-padding-content"
        :readonly="_readOnly"
      />
    </v-container>
    <v-container
      v-if="$slots.footer && isUnitContentVisible"
      class="w-unit__footer"
      fluid
    >
      <slot
        name="footer"
        :readonly="_readOnly"
      />
    </v-container>
  </div>
</template>

<script>
import workUnitMixin from './work-unit-mixin';
import workUnitMobileMixin from './work-unit-mobile-mixin';
import WorkUnitPrependHeader from './WorkUnitPrependHeader';

export default {
  components: {
    WorkUnitPrependHeader,
  },
  mixins: [workUnitMixin, workUnitMobileMixin],
  props: {
    id: String,
    title: { type: String },
    noHeader: Boolean,
    borderColor: { type: String },
    isHeaderSpacerVisible: { type: Boolean, default: true },
  },
  computed: {
    computedBorderStyle() {
      if (this.borderColor)
        return `border-color: var(--v-${this.borderColor}-base);`;
      return '';
    },
  },
};
</script>

<style lang="scss">
@import 'src/components/global_components/unit/WUnit';
</style>
